module.exports = __webpack_public_path__ + "img/zhenduan.d976000a.png";